export const RAFFLE_STATES = {
  NOT_READY: "NOT_READY",
  WAITING_FOR_PLAYERS: "WAITING_FOR_PLAYERS",
  RUNNING: "RUNNING",
  COMPLETED: "COMPLETED",
};

export const TOUR_LEADER = "tour-leader";
